import { render } from "./IncomeProtectionPlanSelection.vue?vue&type=template&id=6004ace1&scoped=true"
import script from "./IncomeProtectionPlanSelection.vue?vue&type=script&lang=js"
export * from "./IncomeProtectionPlanSelection.vue?vue&type=script&lang=js"

import "./IncomeProtectionPlanSelection.vue?vue&type=style&index=0&id=6004ace1&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6004ace1"]])

export default __exports__